import { Component, Input, OnInit } from '@angular/core';
import { SectionTouched } from '../../shared/section-touched.class';
import { environment } from 'src/environments/environment';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { DialogService } from 'src/app/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AbandonmentReportAttachment } from 'src/app/interfaces/abandonment-report-attachment';

@Component({
  selector: 'app-handover-detail-abandonment-report',
  templateUrl: './handover-detail-abandonment-report.component.html',
  styleUrl: './handover-detail-abandonment-report.component.scss',
  standalone: false,
})
export class HandoverDetailAbandonmentReportComponent
  extends SectionTouched
  implements OnInit
{
  @Input() handoverId: number | undefined;
  @Input() readOnlyContent!: boolean;

  isLoading = false;
  abandonmentReportAttachment: any;
  buttonFile = false;
  uploadfile = false;
  fileLimit = 2;
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  constructor(
    private handoverService: HandoverService,
    private notificationService: NotificationService,
    public dialogService: DialogService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.handoverId) {
      this.isLoading = true;
      this.getAbandonmentReportAttachments();
    }
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (this.handoverId && file) {
      this.isLoading = true;
      const formData = new FormData();
      formData.append('file', file);
      this.handoverService
        .saveAbandonmentReportAttachment(this.handoverId, formData)
        .subscribe(
          (uploaded: AbandonmentReportAttachment[]) => {
            if (uploaded) {
              this.uploadfile = true;
              this.getAbandonmentReportAttachments();
            }
          },
          (response: HttpErrorResponse) => {
            this.notificationService.notify(response.error.message, false);
          }
        );
      this.isLoading = false;
    }
  }

  getAbandonmentReportAttachments(): void {
    if (this.handoverId) {
      this.isLoading = true;
      this.handoverService
        .getAbandonmentReportAttachments(this.handoverId)
        .subscribe((file: AbandonmentReportAttachment[]) => {
          if (file) {
            this.abandonmentReportAttachment = file;
            this.buttonFile = true;
            this.uploadfile = true;
          }
          this.isLoading = false;
        });
    }
  }

  deleteAbandonmentReportAttachment(file: any): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Informe de Abandono',
      `¿Está seguro de que desea eliminar el archivo?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        if (!this.handoverId) {
          return;
        }
        this.isLoading = true;
        this.handoverService
          .deleteAbandonmentReportAttachment(this.handoverId, file)
          .subscribe((res: boolean) => {
            if (res) {
              delete this.abandonmentReportAttachment;
              this.getAbandonmentReportAttachments();
            }
            this.isLoading = false;
          });
      }
    });
  }
}
